import { Component, OnInit, OnDestroy } from '@angular/core';
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import { NgModule } from '@angular/core';
import { ngxZendeskWebwidgetModule, ngxZendeskWebwidgetConfig } from 'ngx-zendesk-webwidget';
import { CommonUtil } from 'src/app/core/Utils/common-util';

export class ZendeskConfig extends ngxZendeskWebwidgetConfig {
  accountUrl = 'lifefitness9512.zendesk.com';

  beforePageLoad(zE: any) {
    zE.setLocale(localStorage.getItem('currentlySelectedLanguage'));
    zE.hide();
  }
}

@NgModule({
  imports: [
    ngxZendeskWebwidgetModule.forRoot(ZendeskConfig)
  ]
})
@Component({
  selector: 'app-zendesk-support-widget',
  templateUrl: './zendesk-support-widget.component.html',
  styleUrls: ['./zendesk-support-widget.component.css']
})
export class ZendeskSupportWidgetComponent implements OnInit, OnDestroy {
  locale: string;
  constructor(private ngxZendeskWebwidgetService: ngxZendeskWebwidgetService, private commonUtil: CommonUtil) {
    this.locale = this.commonUtil.rootScopeData.selectedLang;
    localStorage.setItem('currentlySelectedLanguage', this.locale);
    ngxZendeskWebwidgetService.setSettings({
      webWidget: {
        color: { theme: '#eb5f60' },
        offset: {
          horizontal: '10px',
          vertical: '15px'
        },
        position: {
          horizontal: (this.locale == 'ar' || this.locale == 'he') ? 'right' : 'left'
        }
      }
    });
  }

  ngOnInit() {
    this.ngxZendeskWebwidgetService.show();
  }
  ngOnDestroy() {
    this.ngxZendeskWebwidgetService.hide();
  }
}
